import { FC, useCallback, useState } from "react";
import classnames from "classnames";
import { BaseModal } from "../../../atoms/base-modal";
import { RadioButton } from "@graffer-inc/console-design-kit";

export const UserCsvDownloadModal: FC<{
  isActive: boolean;
  onClose: () => void;
  onDownload: (isOutputUserId: boolean) => void;
}> = ({ isActive, onClose, onDownload }) => {
  const [isOutputUserId, setIsOutputUserId] = useState<boolean>(false);
  const handleClick = useCallback(() => {
    onDownload(isOutputUserId);
    onClose();
  }, [isOutputUserId, onDownload, onClose]);

  return (
    <BaseModal title="ユーザーCSV出力" isActive={isActive} onClose={onClose}>
      <>
        <section className="modal-card-body">
          <RadioButton
            label="ユーザーIDの出力"
            description="ユーザーIDの出力有無を選択してください。出力したCSVファイルを元にユーザー一括更新を行う場合、ユーザーIDは出力しないでください。"
            required
            onChange={(e) => setIsOutputUserId(e.target.value === "true")}
            value={isOutputUserId ? "true" : "false"}
            options={[
              {
                name: "ユーザーIDを出力する",
                value: "true",
              },
              {
                name: "ユーザーIDを出力しない",
                value: "false",
              },
            ]}
          />
        </section>
        <footer className="modal-card-foot">
          <button className="button is-failure is-fullwidth" onClick={onClose}>
            キャンセル
          </button>
          <button
            className={classnames("button is-info is-fullwidth")}
            onClick={handleClick}
          >
            CSVを出力する
          </button>
        </footer>
      </>
    </BaseModal>
  );
};
